'use client'

import { Button } from '@heroui/button'
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/modal'
import { format } from 'date-fns'

import { SendIcon2 } from '@/components/shared'
import { Typography } from '@/components/ui'

interface CreateLetterModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  date: Date
}

const CreateLetterModal = ({
  isOpen,
  onOpenChange,
  date,
}: CreateLetterModalProps) => {
  const formattedDate = format(date, 'dd MMMM yyyy')

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      size="xs"
      hideCloseButton
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col items-center pb-0 pt-8">
              <SendIcon2 className="mb-3 text-[56px]" />
              <Typography
                size="2xlarge"
                className="text-center font-crimsonPro"
              >
                Write to Your Future Self
              </Typography>
            </ModalHeader>
            <ModalBody className="flex flex-col items-center pb-0 pt-4">
              <Typography size="xsmall" className="text-center font-outfit">
                Capture your aspirations by sending letters to your future self.
                Set goals, share dreams, and offer words of encouragement to
                support the person you’ll become.
              </Typography>
              <Typography size="xsmall" className="text-center font-outfit">
                We will let you know when it’s time to read your letter by{' '}
                {formattedDate}
              </Typography>
            </ModalBody>
            <ModalFooter className="py-8">
              <Button
                color="primary"
                variant="faded"
                size="lg"
                className="w-full"
                onClick={onClose}
              >
                Continue
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default CreateLetterModal
